import React, { useState } from 'react';
interface FaceLivenessData {
  cert: any;
  handleNext: (data?: any) => void;
  handleBack: () => void;
  startFaceLiveness: () => void;
  pendingDocuments: any;
}

const FaceLiveness: React.FC<FaceLivenessData> = ({
  cert,
  handleNext,
  handleBack,
  startFaceLiveness,
  pendingDocuments,
}) => {
  const [data, setData] = useState<any>({});

  return (
    <div
      className="container-white"
      style={{
        padding: '25px',
        borderRadius: '8px',
        minWidth: 650,
      }}
    >
      <h3
        style={{
          fontSize: '1.4rem',
          fontWeight: 600,
          color: '#333',
          marginBottom: '15px',
          paddingBottom: '10px',
        }}
      >
        Verificación de Vida
      </h3>

      <div
        style={{
          marginBottom: '25px',
          padding: '15px',
          borderLeft: '4px solid #007bff',
          backgroundColor: '#eef4ff',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            margin: 0,
            color: '#011E4A',
            fontSize: '0.95rem',
            fontWeight: 500,
          }}
        >
          Para completar tu solicitud, debes realizar una verificación de vida.
        </p>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <button
            className={`btn w-100`}
            onClick={startFaceLiveness}
            style={{
              marginTop: 72,
              padding: 12,
              fontSize: '1.2rem',
              fontWeight: 'bold',
              background: '#28a745',
              borderColor: '#28a745',
              color: 'white',
              boxShadow: '0 4px 8px rgba(40, 167, 69, 0.4)',
            }}
          >
            <span style={{ fontSize: '1.5rem', marginRight: '10px' }}>📸</span>
            <p style={{ margin: 0 }}>Iniciar Verificación de Identidad</p>
          </button>
        </div>
      </div>

      <div className="row" style={{ marginTop: '72px' }}>
        <div className="col-md-6">
          <button
            disabled={pendingDocuments?.length === 0}
            className={`btn btn-report-2 ${''}`}
            onClick={() => handleBack()}
            style={{ width: '100%', background: '#011E4A !important' }}
          >
            <p>Regresar</p>
          </button>
        </div>

        <div className="col-md-6">
          <button
            className={`btn btn-report ${'active'}`}
            onClick={() => {
              handleNext(data);
            }}
            style={{ width: '100%' }}
          >
            <p>Siguiente</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FaceLiveness;
